;(function() {
  'use strict'

  angular.module('core.addCredit', [])
})()
